import { render, staticRenderFns } from "./sidebar2.vue?vue&type=template&id=6e4bb5ee"
import script from "./sidebar2.vue?vue&type=script&lang=js"
export * from "./sidebar2.vue?vue&type=script&lang=js"
import style0 from "./sidebar2.vue?vue&type=style&index=0&id=6e4bb5ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports